export default __webpack_public_path__ + "static/media/ic_manage-value-added-services.b382aa72.svg";